const AppEvent = {
  /**
   * 触发APP事件
   * @param event 事件名
   * @param data 事件参数
   */
  fire(event: string, data?: any) {
    try {
      (window as any).webkit.messageHandlers.actionClick.postMessage({
        event,
        data,
      });
    } catch (e) {
      console.error(e);
    }
    try {
      // @ts-expect-error: globalThis
      JavaScriptInterface.actionClick(JSON.stringify({ event, data }));
    } catch (e) {
      console.error(e);
    }
  },
};

export default AppEvent;
